import Alas from 'alas';
import alas from './index';
let status = new Alas.Status({
    states: {
        user: () => alas.make('user', 'profile'),
        farm: () => alas.make('farm', 'farm'),
        farms: () => alas.makeList('farm', 'farm', { save: false }),
        cycle: () => alas.make('farm', 'cycle'),
        cycles: () => alas.makeList('farm', 'cycle', { save: false }),
        picture: () => alas.make('farm', 'picture'),
        pictures: () => alas.makeList('farm', 'picture', { save: false }),
        types: () => alas.makeList('crop', 'type'),
        config: () => alas.make('user', 'config'),
        userConfig: () => alas.make('user', 'userConfig')
    }
});
export default status;
